import { api } from "assets/scripts/utilities/api-clients";

const createOrganisationPayload = (organisation) => {
  const {
    _id,
    internal_number,
    tax_settings,
    credit_cycle,
    credit_limit,
    advance_limit,
    pan,
    is_gst_registered,
    gstin_business,
  } = organisation;

  return {
    _id,
    internal_number,
    tax_settings,
    credit_cycle,
    credit_limit,
    advance_limit,
    gstin: is_gst_registered ? gstin_business : "",
    pan,
  };
};

export const index = async (options = {}) => {
  const response = await api.get("/kam/organisations", options);

  return response;
};

export const post = async (organisation, options) => {
  const {
    tax_settings,
    credit_cycle,
    credit_limit,
    advance_limit,
    pan,
    name,
    gstin,
    is_gst_registered,
    gstinList,
  } = organisation;

  const payload = {
    tax_settings,
    credit_cycle,
    credit_limit,
    advance_limit,
    pan,
    name,
    gstin,
    is_gst_registered,
    gstinList,
  };

  const response = await api.post("/kam/organisation", payload, options);

  return response;
};

export const getGstDetails = async (options) => {
  const { gstin, user_id } = options;
  const response = await api.get(`/kam/gst-details/${gstin}`, {
    params: { user_id },
  });

  return response;
};

export const get = async (id) => {
  const response = await api.get(`/kam/organisation/${id}`);

  return response;
};

export const put = async (organisation) => {
  const { apply_limit_to_associated = false, ...rest } = organisation;

  const payload = createOrganisationPayload(rest);

  const options = {
    params: {
      apply_limit_to_associated,
    },
  };

  const response = await api.put(
    `/kam/organisation/${rest._id}`,
    payload,
    options,
  );

  return response;
};

export const getUnregistered = async (options) => {
  const response = await api.get(`/kam/organisation/unregistered`, options);

  return response;
};

export const getUserActiveStatus = async (id) => {
  const response = await api.get(`/kam/organisation/checkUserStatus/${id}`);

  return response;
};

export const getPanDetails = async (pan, options) => {
  const response = await api.get(`/kam/pan-details/${pan}`, options);

  return response;
};

export const putDeactivateOrgstatus = async (id) => {
  const response = await api.put(`/kam/organisation/deactivate/${id}`);

  return response;
};

export const putActivateOrgstatus = async (id) => {
  const response = await api.put(`/kam/organisation/activate/${id}`);

  return response;
};

export const getLastUserStatus = async (options) => {
  const response = await api.get(`/kam/organisation/allOrgUserStatus`, options);

  return response;
};

export const validateOrganisation = async (options) => {
  const response = await api.get(
    `/kam/organisation/check-organisation`,
    options,
  );

  return response;
};
